import { Controller } from "@hotwired/stimulus"

// Управляет шапкой: тень при скролле, мобильное меню, плавная прокрутка к якорям.
export default class extends Controller {
  static targets = ["bar", "menu"]

  connect() {
    this.onScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.onScroll, { passive: true })
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
  }

  handleScroll() {
    const bar = this.hasBarTarget ? this.barTarget : this.element
    if (window.scrollY > 20) {
      bar.classList.add("scrolled")
    } else {
      bar.classList.remove("scrolled")
    }
  }

  toggleMenu() {
    this.menuTarget?.classList.toggle("open")
  }

  closeMenu() {
    this.menuTarget?.classList.remove("open")
  }

  scrollToForm() {
    document.getElementById("form")?.scrollIntoView({ behavior: "smooth" })
  }

  scrollToFormAndClose() {
    this.closeMenu()
    this.scrollToForm()
  }

  scrollTo(event) {
    const targetId = event.params?.target
    if (targetId) {
      document.getElementById(targetId)?.scrollIntoView({ behavior: "smooth" })
    }
  }
}
